// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Definisi terjemahan
const resources = {
  en: {
    translation: {
      welcome: "Welcome to React and react-i18next",
      description: "This is a simple example",
    },
  },
  id: {
    translation: {
      welcome: "Selamat datang di React dan react-i18next",
      description: "Ini adalah contoh sederhana",
    },
  },
};

// Inisialisasi i18next
i18n
  .use(LanguageDetector) // Menggunakan deteksi bahasa otomatis
  .use(initReactI18next) // Menghubungkan dengan react-i18next
  .init({
    resources,
    fallbackLng: "id", // Bahasa default
    interpolation: {
      escapeValue: false, // React secara otomatis melindungi XSS
    },
  });

export default i18n;
